export default {
    midConfig: {
        orgId: 'EA673DFC5A2F19060A495C9C@AdobeOrg',
        cookieKeyPre: 'AMCV_',
    },
    javaScriptVer: '1.8.5',
    visitorIdKey: 'v1st',
    smSessionKey: 'SMSESSION'
};
